import { render, staticRenderFns } from "./RightsFundLogStatistics.vue?vue&type=template&id=6a71800e"
import script from "./RightsFundLogStatistics.vue?vue&type=script&lang=js"
export * from "./RightsFundLogStatistics.vue?vue&type=script&lang=js"
import style0 from "./RightsFundLogStatistics.vue?vue&type=style&index=0&id=6a71800e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports